"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KioskStruct = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
exports.KioskStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    userUniqueId: (0, superstruct_1.string)(),
    printerId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    lastActionAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    sessions: (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), utils_1.TimestampStruct)),
    createdAt: utils_1.TimestampStruct,
    updatedAt: utils_1.TimestampStruct,
});
exports.KioskStruct.type = 'Kiosk';
//# sourceMappingURL=kiosk.js.map